import styled from 'styled-components/macro';
import { colorBlackTransparent50, colorCoreBlack900Base } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
export const CountStyled = styled.span `
  padding: 6px ${INDENT.xxs};

  ${getTextStyles('Ubuntu', 500, 12, 16)}

  color: ${colorCoreBlack900Base};
  background-color: ${colorBlackTransparent50};
  border-radius: ${CORNER_RADIUS.xl};
`;
